
import { ymGoalCheck } from '~/helpers/ym_helper';

export default {
  name: 'ProductPageTemplate',

  props: {
    isAddToCart: {
      type: Boolean,
      default: false,
    },

    countAddedToCart: {
      type: Number,
      default: null,
    },
  },

  emits: ['addProductToCard', 'changeProductCount'],

  methods: {
    addProductToCard() {
      ymGoalCheck({
        ymGoal: 'add_to_cart',
        ymNumber: process.env.yandexMetriks,
      });
      this.$emit('addProductToCard', { isChangeQuantity: true, isClear: this.isAddToCart });
    },

    changeProductCount(count) {
      this.$emit('changeProductCount', count);
    }
  },
};
